if($('#component-approval-status').length){
    var app = new Vue({
        el: '#component-approval-status',
        data: {
            status_id: status_id,
            networkId: networkId,
            applicationId: applicationId,
            applicationType: applicationType,
        },
        methods: {
            changeStatus(){
                if(this.status_id == 1){
                    var status = 'approved';
                }else if(this.status_id == 2){
                    var status = 'disapproved';
                }
                axios.get('/api/v1/network/'+this.networkId+'/'+this.applicationType+'/update-status/'+this.applicationId+'/'+status ).then(() =>  {
                    this.$toasted.success('Application Status Updated');
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            errorHandler(error){
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else{
                    this.$toasted.error(error.response.data.message);
                }
            }
        },
        mounted () {

            // ApplicationResponseService.getApplicationResponses().then(data => {
            //     this.applicationResponses = data;
            // });

            // StatusService.getStatuses().then(data => {
            //     this.statuses = data;
            // });
        }
    });
}